<template>
  <Card style="min-height: 460px">
    <template v-slot:title>Bovinos vendidos</template>
    <template v-slot:content>
      <DataTable
        dataKey="id"
        :value="results"
        :scrollHeight="$isLargeScreen.value ? '500px' : undefined"
        :scrollable="$isLargeScreen.value"
        responsiveLayout="stack"
      >
        <Column
          header="Brinco"
          field="bovine.earring"
          :sortable="true"
          headerStyle="min-width: 90px"
          style="min-width: 90px"
          alignFrozen="left"
          :frozen="true"
        >
          <template #body="{ data }">
            <router-link
              :to="{ name: 'bovine.edit', params: { id: data.bovineId } }"
              target="_blank"
              style="text-decoration: none"
            >
              {{ data.bovine.earring }}
            </router-link>
          </template>
        </Column>
        <Column
          header="Tipo"
          field="bovine.type.name"
          :sortable="true"
          :headerStyle="headerStyle"
          :style="headerStyle"
          alignFrozen="left"
          :frozen="true"
        >
          <template #body="{ data }">
            <router-link
              :to="{ name: 'bovine.edit', params: { id: data.bovineId } }"
              target="_blank"
              style="text-decoration: none"
            >
              <BovineType :type="data.bovine.type" small />
            </router-link>
          </template>
        </Column>
        <Column
          header="Peso"
          field="weight"
          :sortable="true"
          :headerStyle="headerStyle"
          :style="headerStyle"
        >
          <template #body="{ data: { weight } }">
            {{ weight ? $toDecimal(weight) : '-' }}
          </template>
        </Column>
        <Column
          header="Tipo de cálculo"
          field="calculationTypeId"
          :sortable="true"
          :headerStyle="headerStyle"
          :style="headerStyle"
        >
          <template #body="{ data }">
            <span v-if="data.calculationTypeId === 1">KG</span>
            <span v-else-if="data.calculationTypeId === 2">Arroba</span>
            <span v-else-if="data.calculationTypeId === 3">Valor</span>
            <span v-else>-</span>
          </template>
        </Column>
        <Column
          header="Valor"
          field="value"
          :sortable="true"
          :headerStyle="headerStyle"
          :style="headerStyle"
        >
          <template #body="{ data }">
            {{ $toCurrency(data.value) }}
          </template>
        </Column>
        <Column
          header="Valor total"
          field="totalValue"
          :sortable="true"
          :style="headerStyle"
        >
          <template #body="{ data }">
            {{ $toCurrency(data.totalValue) }}
          </template>
        </Column>
        <Column
          header="Touro"
          field="bullType"
          :sortable="true"
          :headerStyle="headerStyle"
          :style="headerStyle"
        >
          <template #body="{ data }">
            {{ data.bullTypeName || '-' }}
          </template>
        </Column>
        <Column
          header="Raça"
          field="breedName"
          :sortable="true"
          :headerStyle="headerStyle"
          :style="headerStyle"
        >
          <template #body="{ data }">
            {{ data.breedName || '-' }}
          </template>
        </Column>
        <Column
          header="Data de nascimento"
          field="bovine.birthDate"
          :sortable="true"
          :headerStyle="headerStyle"
          :style="headerStyle"
        >
          <template #body="{ data }">
            {{
              data.bovine.birthDate
                ? $dayjs(data.bovine.birthDate).format('DD/MM/YYYY')
                : '-'
            }}
          </template>
        </Column>
        <Column
          header="Fazenda"
          field="farmName"
          :sortable="true"
          :headerStyle="headerStyle"
          :style="headerStyle"
        >
          <template #body="{ data }">
            <router-link
              v-if="data.farmName"
              :to="{ name: 'farm.edit', params: { id: data.bovine?.farmId } }"
              target="_blank"
              style="text-decoration: none"
              >{{ data.farmName }}</router-link
            >
            <span v-else> - </span>
          </template>
        </Column>
      </DataTable>
    </template>
  </Card>
</template>

<script>
import { mapGetters } from 'vuex';
import BovineType from '../../../components/BovineType';

export default {
  name: 'SaleBovineReviewCard',
  components: {
    BovineType,
  },
  data() {
    return {
      headerStyle: 'min-width: 100px',
    };
  },
  props: {
    saleBovines: Array,
  },
  computed: {
    ...mapGetters('sale', ['totalValueByBovine']),
    results() {
      return this.saleBovines.map((saleBovine) => {
        return {
          ...saleBovine,
          breedName: saleBovine.bovine?.breed?.name,
          farmName: saleBovine.bovine?.farm?.name,
          bullTypeName: saleBovine.bovine?.bullType?.name,
          totalValue: this.totalValueByBovine[saleBovine.bovineId],
        };
      });
    },
  },
};
</script>

<style>
</style>